jQuery(document).ready(function ($) {
    "use strict";

    $('#btn-mobile').on('click', function(){
        $('#header-menu ul').slideToggle();
    });

    $('.produto-imagem-nav-item > a').on('click', function(e){
        e.preventDefault();
        var $newSrcMediumLarge = $(this).attr('data-src-medium-large'); 
        var $newSrcLarge = $(this).attr('data-src-large'); 
        $('.produto-imagem-show > .img-produto').fadeOut('slow', function(){
            $('.produto-imagem-show > .img-produto').attr('src', $newSrcMediumLarge);
            $('.produto-imagem-show > .img-produto').attr('srcset', $newSrcMediumLarge);
            $('.produto-imagem-show > .btn-zoom').attr('href', $newSrcLarge);
            $('.produto-imagem-show > .img-produto').fadeIn();
        });
        
    });

    lightbox.option({
        'albumLabel': "Imagem %1 de %2",
        'disableScrolling': true,
        'showImageNumberLabel': false,
        'resizeDuration': 200,
        'positionFromTop': 100,
        'wrapAround': false
    });

});